import { ApexOptions } from 'apexcharts';
import ReactApexChart from 'react-apexcharts';

import usePostgreMappingWidgetData from '../../../hooks/usePostgreMappingWidgetData';
import { IPostgreMappingsWidgetProp } from '../types';

const MappingStackedBarChartPostgre = ({ query, title }: IPostgreMappingsWidgetProp) => {
  const { widgetData } = usePostgreMappingWidgetData(query);

  const options: ApexOptions = {
    chart: {
      stacked: true,
      height: '70%',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    xaxis: {
      type: 'datetime',
      labels: {
        datetimeUTC: false,
      },
      categories: widgetData.categories ?? [],
    },
    yaxis: {
      title: {
        text: 'Count',
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'left',
      offsetX: 50,
    },
    stroke: {
      width: 1,
    },
    dataLabels: {
      enabled: false,
    },
    title: {
      text: title,
      style: {
        fontSize: '12px',
      },
    },
  };

  return (
    <ReactApexChart
      options={options}
      series={(widgetData.series ?? []) as ApexAxisChartSeries}
      type="bar"
      width="100%"
      height="100%"
    />
  );
};

export default MappingStackedBarChartPostgre;
